export const validate = (values) => {
    const errors = {};

    /**
     * (code >= 0x0E01 && code <= 0x0E2E) || // ก - ฮ (main Thai letters)
     * (code >= 0x0E30 && code <= 0x0E3A) || // vowels like ะ า ำ ิ ี ึ ื ุ ู
     * (code >= 0x0E40 && code <= 0x0E4E);   // tone marks, diacritics, etc.
     */
    const alphabeticRegex =
        /^[\u0E01-\u0E2E\u0E30-\u0E39\u0E40-\u0E4E\u0E47\u0E48\u0E49\u0E4A\u0E4C\u0E4D\u0E4E a-zA-Z'-]+$/;
    const emailRegex =
        /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;

    // ชื่อ
    if (!values.firstName) {
        errors.firstName = 'กรุณากรอกชื่อ';
    } else if (!alphabeticRegex.test(values.firstName)) {
        errors.firstName =
            'ชื่อสามารถกรอกได้เฉพาะอักษรไทย/อังกฤษ และเว้นวรรคเท่านั้น';
    } else if (values.firstName.length > 50) {
        errors.firstName = 'ชื่อไม่เกิน 50 ตัวอักษร';
    }

    // นามสกุล
    if (!values.lastName) {
        errors.lastName = 'กรุณากรอกนามสกุล';
    } else if (!alphabeticRegex.test(values.lastName)) {
        errors.lastName =
            'นามสกุลสามารถกรอกได้เฉพาะอักษรไทย/อังกฤษ และเว้นวรรคเท่านั้น';
    } else if (values.lastName.length > 50) {
        errors.lastName = 'นามสกุลไม่เกิน 50 ตัวอักษร';
    }

    // ชื่อหน่วยงาน/บริษัท
    if (!values.companyName) {
        errors.companyName = 'กรุณากรอกชื่อหน่วยงาน/บริษัท';
    } else if (values.companyName.length > 50) {
        errors.companyName = 'ชื่อหน่วยงาน/บริษัทไม่เกิน 50 ตัวอักษร';
    }

    // ตำแหน่งงาน
    if (!values.position) {
        errors.position = 'กรุณากรอกตำแหน่งงาน';
    } else if (values.position.length > 50) {
        errors.position = 'ตำแหน่งงานไม่เกิน 50 ตัวอักษร';
    }

    // อีเมล
    if (!values.email) {
        errors.email = 'กรุณากรอกอีเมล';
    } else if (!emailRegex.test(values.email)) {
        errors.email = 'รูปแบบอีเมลไม่ถูกต้อง';
    } else if (values.email.length > 50) {
        errors.email = 'อีเมลไม่เกิน 50 ตัวอักษร';
    }

    return errors;
};
